import * as specialLinkStyles from "../../../styles/admissions/admissions.module.scss";
import React from "react";

import IconContainer from "../IconContainer";
import PolyLink from "../PolyLink";

const SpecialLink = ({
  subtitle,
  title,
  icon,
  link,
  disable,
  arrowDisable,
  lowcase,
  color,
  textTransform,
                       isRelatedContent = false,
                       window = false
}) => {
  const style = {};
  style.fontWeight = 600;
  if (color) {
    style.color = color;
  }
  if (textTransform === "none") {
    style.textTransform = "none";
  }

  const content = (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        width: "inherit",
      }}
    >
      <div>
        <p
          style={style}
          className={isRelatedContent ? specialLinkStyles.relatedContentTitle : specialLinkStyles.title}
        >
          {title}
        </p>
        <p
          style={style}
          className={isRelatedContent ? specialLinkStyles.relatedContentTitle : specialLinkStyles.title}
        >
          {subtitle}
        </p>
      </div>

      {!arrowDisable && (
        <div>
          <IconContainer icon={"ARROW_RIGHT_NORMAL"} color="BLACK" size={20} style={{"paddingTop": "3px"}}/>
        </div>
      )}
    </div>
  );

  return (
    <>
      <div className={specialLinkStyles.specialLinkContent}>
        <div style={{ marginRight: 15 }}>{icon}</div>
        {disable ? (
          <div style={{ width: "100%" }}>{content}</div>
        ) : (
          <PolyLink
              target={window ? "_blank" : ""}
            url={link}
            rel="noreferrer"
            className={specialLinkStyles.special_link}
          >
            {content}
          </PolyLink>
        )}
      </div>
    </>
  );
};

export default SpecialLink;
